<template>
  <mobile-status-section
    :statuses="statuses"
    :records="records"
  ></mobile-status-section>
</template>

<script>
import MobileStatusSection from "../../components/MobileStatusSection";

export default {
  name: "CompletedPipelineMobile",
  components: {MobileStatusSection},
  data() {
    return {
      pageLoading: false,
    };
  },
  computed: {
    statuses() {
      return this.$store.getters["pipeline/completedStatusesInView"];
    },
    records() {
      return this.$store.getters["completedState/records"]
    }
  },
  created() {
    this.$store.dispatch("completedState/setup").then(() => {
      this.pageLoading = false;
    });
  },
  destroyed() {
    this.$store.dispatch("completedState/teardown");
  },
};
</script>
